import { c as _c } from "react/compiler-runtime";
import React from 'react';
const ProductCardImageComingSoon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <img alt="" className="absolute w-[80%] max-w-full h-[80%] max-h-full top-[10%] left-[10%] object-contain" src="/static/assets/icons/image-coming-soon.svg" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ProductCardImageComingSoon;